import React from 'react';
import styled from 'styled-components';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PageContainer = styled.div`
  padding-top: var(--header-h);
  min-height: 100vh;
  background: white;
  width: 100%;
`;

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px 60px;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 30px;
  transition: color 0.3s ease;

  &:hover {
    color: #666;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 30px;
  font-weight: 300;
`;

const Content = styled.div`
  background: white;
  border-radius: 15px;
  padding: 40px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e0e0e0;
  line-height: 1.8;
  color: #333;

  h2 {
    font-size: 1.8rem;
    color: #333;
    margin-top: 30px;
    margin-bottom: 15px;
    font-weight: 600;
  }

  h3 {
    font-size: 1.3rem;
    color: #333;
    margin-top: 25px;
    margin-bottom: 12px;
    font-weight: 600;
  }

  p {
    margin-bottom: 15px;
    font-size: 1rem;
  }

  ul {
    margin-left: 20px;
    margin-bottom: 15px;
  }

  li {
    margin-bottom: 8px;
  }
`;

const GizlilikPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <Container>
        <BackButton onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
          Geri Dön
        </BackButton>

        <Title>Gizlilik Sözleşmesi</Title>

        <Content>
          <h2>1. Genel Bilgiler</h2>
          <p>
            Saraylı Moda olarak, kişisel verilerinizin korunmasına büyük önem veriyoruz. Bu gizlilik sözleşmesi, 
            kişisel verilerinizin nasıl toplandığı, kullanıldığı ve korunduğu hakkında bilgi vermektedir.
          </p>

          <h2>2. Toplanan Bilgiler</h2>
          <p>Aşağıdaki bilgileri topluyoruz:</p>
          <ul>
            <li>Ad, soyad, e-posta adresi, telefon numarası</li>
            <li>Fatura ve teslimat adresi bilgileri</li>
            <li>Ödeme bilgileri (güvenli ödeme sistemleri üzerinden)</li>
            <li>IP adresi ve tarayıcı bilgileri</li>
            <li>Sipariş geçmişi ve tercihleriniz</li>
          </ul>

          <h2>3. Bilgilerin Kullanımı</h2>
          <p>Toplanan bilgiler aşağıdaki amaçlarla kullanılmaktadır:</p>
          <ul>
            <li>Siparişlerinizin işlenmesi ve teslim edilmesi</li>
            <li>Müşteri hizmetleri sağlanması</li>
            <li>Yasal yükümlülüklerin yerine getirilmesi</li>
            <li>Pazarlama ve promosyon faaliyetleri (izin verdiğiniz takdirde)</li>
          </ul>

          <h2>4. Bilgilerin Paylaşımı</h2>
          <p>
            Kişisel bilgileriniz, yasal yükümlülükler dışında üçüncü taraflarla paylaşılmamaktadır. 
            Ödeme işlemleri için güvenli ödeme sistemleri kullanılmaktadır.
          </p>

          <h2>5. Güvenlik</h2>
          <p>
            Kişisel verilerinizin güvenliği için SSL şifreleme ve güvenli ödeme sistemleri kullanılmaktadır.
          </p>

          <h2>6. Haklarınız</h2>
          <p>KVKK kapsamında aşağıdaki haklara sahipsiniz:</p>
          <ul>
            <li>Kişisel verilerinize erişim</li>
            <li>Kişisel verilerinizin düzeltilmesi</li>
            <li>Kişisel verilerinizin silinmesi</li>
            <li>İtiraz etme hakkı</li>
          </ul>

          <h2>7. İletişim</h2>
          <p>
            Gizlilik politikamız hakkında sorularınız için:
          </p>
          <p>
            <strong>E-posta:</strong> info@saraylimoda.com<br />
            <strong>Telefon:</strong> 0224 221 51 20
          </p>
        </Content>
      </Container>
    </PageContainer>
  );
};

export default GizlilikPage;

